export default __webpack_public_path__ + "static/media/mm.53de19a4.svg";